import { Component, OnInit } from '@angular/core';
import { AppUtils } from '@libs/utils/app.utils';



@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

	public headerDetails: any;
	public accessToken: any;
	public targetUrl: string;
	public subscription: any;

	constructor(private appUtils: AppUtils) {
		this.targetUrl = window.location.href;
		window.scrollTo({ top: 0, behavior: 'smooth' });
	}

	ngOnInit(): void {
		this.accessToken = localStorage.getItem('access_token');
		//uncomment the next line to work locally
        // localStorage.setItem(
        //   "access_token",
        //   "eyJhbGciOiJSUzI1NiIsImtpZCI6IlRlc3RUb2tlbiIsIng1dCI6InBnZnVOb0dIZk1kZkRXUVFLS1RkVUxydEoyOCIsInBpLmF0bSI6IjEifQ.eyJzY29wZSI6Im9wZW5pZCIsImNsaWVudF9pZCI6Ik9tbml0cmFjc19PbmVDQyIsImlzcyI6Imh0dHBzOi8vZmVkc3NvLnBlcmYub21uaXRyYWNzLmNvbSIsImF1ZCI6Ik9tbml0cmFjc19PbmUiLCJleHAiOjE3MTI5NDM0MTB9.GE3edf7w_vMzZLMY09TXD5DMDCRv3Xp9_Hqhk_U4qRDJCcdLojb3ltX6ZRs_0wqWi6LeyH8CXRo3_Pq1Yw2ZdrO3HbCyEv2_gjPUvK4l6yc3QIBdPE9PEvjo4uu3_vY5a0mY8f2RGwE89zAFqmKsaKybKdGjhG8sdKCdloJtY_l1oHdAGmmWbFlOOYaN1zzcysZuN1FwdF6dNdSbURNkpKEv8VtRyfoZzEnFjA33Kg9EuHrVp57pKMKMpbEzPfSAPA--hhB0m8UXLz2es9HlbzRh9P8mZ6HZ3G_r-IuJJLs4lWIkXdM0VWrWKdXvQXgyUwKj5US3mEPrTvi8J88M7w"
        // );
		if (!this.accessToken && location.href.indexOf('access_token=') > -1 && location.href.split('&').indexOf('authn_token_type=Bearer') > -1) {
			this.accessToken = location.href.split('&')[1].split('access_token=')[1];
			localStorage.setItem('access_token', this.accessToken);
		}

		if (this.accessToken) {
			const token: any = JSON.parse(this.appUtils.decodeJWT(this.accessToken));
			token.co = token['omnitracs.com/business_account'];
			delete token['omnitracs.com/business_account'];
			let perms = token['omnitracs.com/business_account_permissions'];
			if (perms && Object.keys(perms).length != 0) {
				token['omnitracs.com/business_account_permissions'] = Object.assign(token['omnitracs.com/business_account_permissions'], token['omnitracs.com/system_permissions']);
			}
			let decodedToken = JSON.stringify(token).replace(/omnitracs.com\/business_account_permissions/g, 'capas');
			localStorage.setItem('decoded_token', decodedToken);
		}

		this.appUtils.getData().subscribe(data => {
			this.headerDetails = data;
			if (!this.headerDetails || !this.headerDetails?.title) {
				setTimeout(() => {
					this.setUpGlobalNav();
				}, 300);
			}
		});
	}

	// Method to setup global nav data.
	setUpGlobalNav() {
		let timer = setInterval(() => {
		}, 10);
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

}